import { Component, OnInit } from '@angular/core';
import { ChangePasswordService } from './change-password.service';
import swal from 'sweetalert2';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { ChangePassword } from './change-password';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MustMatch } from '../common/custom-validators/must-match.validator';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {

  password: ChangePassword = new ChangePassword();
  form : FormGroup;
  submitted: boolean;

  constructor(private changePasswordService : ChangePasswordService, private formBuilder: FormBuilder,config: NgbModalConfig, private modalService: NgbModal) { }


  ngOnInit() {
    this.form = this.formBuilder.group({
      oldPassword: ['', Validators.required],
      newPassword: ['', [Validators.required]],
      confirmPassword: ['', Validators.required]
  }, {
      validator: MustMatch('newPassword', 'confirmPassword')
  });
  }

  // convenience getter for easy access to form fields
  get f() { return this.form.controls; }

  onSubmit() {
    this.submitted = true;
    // console.log(this.form.invalid);
    // stop here if form is invalid
    if (this.form.invalid) {
        return false;
    }
   // this.changePassword();
}

  changePassword() {
    this.changePasswordService.changePassword(this.password).subscribe(res => {
        if (res['code'] === 0) {
            Swal.fire('Saved!', res['message'], 'success')
            this.clear();
        }
        else {
            swal.fire('Saving Error : ', res['message'], 'error');
            this.clear();
        }
    });


}

clear() {
    this.submitted = false;
    
}

}



